import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
let head = document.getElementsByTagName("head");
let meta = document.createElement("meta");
meta.name = "referrer";
//根据实际情况修改referrer的值，可选值参考上文
meta.content = "no-referrer";
head[0].appendChild(meta);

const routes = [{
    path: "/interview", name: "访问", component: () => import("../components/interview.vue"),
}, {
    path: "/login", name: "登录", component: () => import("../views/index/login/login.vue"),
}, {
    path: "/qrCodePage",
    name: "二维码页面",
    component: () => import("../views/assetManagement/qrCodePage/index.vue"),
},
{
    path: "/riskEventTable",
    name: "风险事件配置",
    component: () => import("@/views/doublePrevention/riskEventAllocation/riskEventTable.vue"),
},
// 首页
{
    path: "/",
    name: "首页",
    component: () => import("../views/index/index.vue"),
    redirect: "/homePage",
    children: [{
        path: "/homePage", name: "首页", component: () => import("../views/index/home/homeIndex.vue"),
    }, {
        path: "/newsDetails",
        name: "新闻详情",
        component: () => import("../views/index/home/components/newsDetails.vue"),
    }, {
        path: "/newsPage", name: "新闻", component: () => import("../views/index/home/newsPage.vue"),
    },],
}, // 系统管理       对应目录---> system
{
    path: "/index", name: "系统管理", component: () => import("../views/index/index.vue"), children: [{
        path: "company/manager",
        name: "公司管理",
        component: () => import("../views/system/companyManager/manager.vue"),
    }, {
        path: "userMange", name: "用户管理", component: () => import("../views/system/user/table.vue"),
    }, {
        path: "roleMange", name: "角色管理", component: () => import("../views/system/role/table.vue"),
    }, {
        path: "menuManage", name: "菜单管理", component: () => import("../views/system/menu/table.vue"),
    },],
}, // 环保管理       对应目录---> environmentalMan
{
    path: "/index", name: "环保管理", component: () => import("../views/index/index.vue"), children: [{
        path: "environmentalMan/fqplStatistica",
        name: "废气排量统计",
        component: () => import("@/views/environmentalMan/fqplStatistica.vue"),
    }, {
        path: "environmentalMan/fqMonitor",
        name: "废气监测",
        component: () => import("@/views/environmentalMan/fqMonitor.vue"),
    }, {
        path: "environmentalMan/fgpccInHistory",
        name: "固废品产进历史记录",
        component: () => import("@/views/environmentalMan/fgpccInHistory.vue"),
    }, {
        path: "environmentalMan/fgpccOutHistory",
        name: "固废品转出历史记录",
        component: () => import("@/views/environmentalMan/fgpccOutHistory.vue"),
    },

    {
        path: "environmentalMan/fqMonitorHistory",
        name: "废气监测历史记录",
        component: () => import("@/views/environmentalMan/fqMonitorHistory.vue"),
    }, {
        path: "environmentalMan/hjMonitor",
        name: "环境监测",
        component: () => import("@/views/environmentalMan/hjMonitor.vue"),
    }, {
        path: "environmentalMan/hjMonitorHistory",
        name: "环境监测历史记录",
        component: () => import("@/views/environmentalMan/hjMonitorHistory.vue"),
    }, {
        path: "environmentalMan/zyMonitor",
        name: "噪音监测",
        component: () => import("@/views/environmentalMan/zyMonitor.vue"),
    }, {
        path: "environmentalMan/zyMonitorHistory",
        name: "噪音监测历史记录",
        component: () => import("@/views/environmentalMan/zyMonitorHistory.vue"),
    }, {
        path: "environmentalMan/yzMonitor",
        name: "监测因子配置",
        component: () => import("@/views/environmentalMan/yzMonitor.vue"),
    }, {
        path: "environmentalMan/monitorWarningList",
        name: "监测报警列表",
        component: () => import("@/views/environmentalMan/monitorWarningList.vue"),
    }, {
        path: "environmentalMan/gfpSetting",
        name: "固废品配置",
        component: () => import("@/views/environmentalMan/gfpSetting.vue"),
    }, {
        path: "environmentalMan/ccddSetting",
        name: "存储地点配置",
        component: () => import("@/views/environmentalMan/ccddSetting.vue"),
    }, {
        path: "environmentalMan/gfpccStatistica",
        name: "固废品存储统计",
        component: () => import("@/views/environmentalMan/gfpccStatistica.vue"),
    }, {
        path: "environmentalMan/pfPermit",
        name: "排放许可证",
        component: () => import("@/views/environmentalMan/pfPermit.vue"),
    },],
}, // 生产管理       对应目录---> produceViews
{
    path: "/index", name: "生产管理", component: () => import("../views/index/index.vue"), children: [{
        path: "produceViews/productionOverview",
        name: "产量概览",
        meta: { title: "产量概览" },
        component: () => import("../views/produceViews/productionOverview.vue"),
    }, {
        path: "produceViews/productionDetails",
        name: "产量详情",
        component: () => import("../views/produceViews/componens/productionDetails.vue"),
    }, {
        path: "produceViews/productionUp",
        name: "产量上报",
        component: () => import("../views/produceViews/productionUp.vue"),
    },],
}, // 能耗管理       对应目录---> energyConsumption
{
    path: "/index", name: "能耗管理", component: () => import("../views/index/index.vue"), children: [{
        path: "energyConsumption/consumePower",
        name: "耗电统计",
        component: () => import("../views/energyConsumption/consumePower/consumePower.vue"),
    }, {
        path: "energyConsumption/waterConsumption", name: "耗水统计", component: () => import(
            "../views/energyConsumption/waterConsumption/waterConsumption.vue"
        ),
    }, {
        path: "energyConsumption/warningHistory", name: "预警历史", component: () => import(
            "../views/energyConsumption/warningHistory/warningHistory.vue"
        ),
    }, {
        path: "energyConsumption/electricEnergyMonitoring", name: "电能监测", component: () => import(
            "../views/energyConsumption/electricEnergyMonitoring/electricEnergyMonitoring.vue"
        ),
    }, {
        path: "energyConsumption/historicRecords", name: "电能监测-历史记录", component: () => import(
            "../views/energyConsumption/electricEnergyMonitoring/historicRecords.vue"
        ),
    }, {
        path: "energyConsumption/monitoringFactors", name: "监测因子配置", component: () => import(
            "../views/energyConsumption/monitoringFactors/monitoringFactors.vue"
        ),
    }, {
        path: "energyConsumption/utilizationRate", name: "利用率记录", component: () => import(
            "../views/energyConsumption/utilizationRate/utilizationRate.vue"
        ),
    },],
}, // 设备管理       对应目录---> device
{
    path: "/index", name: "设备管理", component: () => import("../views/index/index.vue"), children: [{
        path: "device/deviceInfo", name: "设备档案", component: () => import("@/views/device/deviceInfo/table.vue"),
    }, {
        path: "device/deviceType",
        name: "设备类型",
        component: () => import("@/views/device/deviceType/deviceType.vue"),
    }, {
        path: "device/warning", name: "异常预警", component: () => import("@/views/device/deviceWarning/table.vue"),
    },],
}, // 原料管理       对应目录---> warehouseManagement
{
    path: "/index", name: "原料管理", component: () => import("../views/index/index.vue"), children: [{
        path: "warehouseManagement/stockOverview",
        name: "库存概览",
        component: () => import("../views/warehouseManagement/stockOverview.vue"),
    }, {
        path: "warehouseManagement/rawMaterialInventory",
        name: "原料库存",
        component: () => import("../views/warehouseManagement/rawMaterialInventory.vue"),
    }, {
        path: "warehouseManagement/rawMaterialAdd",
        name: "原料入库",
        component: () => import("../views/warehouseManagement/rawMaterialAdd.vue"),
    }, {
        path: "warehouseManagement/rawMaterialReduce",
        name: "原料出库",
        component: () => import("../views/warehouseManagement/rawMaterialReduce.vue"),
    }, {
        path: "warehouseManagement/rawMaterialTypeManage",
        name: "原料类型管理",
        component: () => import("../views/warehouseManagement/rawMaterialTypeManage.vue"),
    }, {
        path: "warehouseManagement/rawMaterialTest",
        name: "原料检验",
        component: () => import("../views/warehouseManagement/rawMaterialTest.vue"),
    }, {
        path: "warehouseManagement/supplierManage",
        name: "供应商管理",
        component: () => import("../views/warehouseManagement/supplierManage.vue"),
    }, {
        path: "warehouseManagement/wareHouseWei",
        name: "仓库维护",
        component: () => import("../views/warehouseManagement/wareHouseMaintenance.vue"),
    },],
}, // 管控管理       对应目录---> ControlManagement
{
    path: "/index", name: "管控管理", component: () => import("../views/index/index.vue"), children: [{
        path: "/VisitorRegistrationRecordCfg", name: "访客登记记录", component: () => import(
            "@/views/ControlManagement/VisitorRegistrationRecord/VisitorRegistrationRecordCfg.vue"
        ),
    }, {
        path: "/ControlManagement/BeaconConfiguration", name: "信标配置", component: () => import(
            "../views/ControlManagement/BeaconConfiguration/physicalExaminationStatistics.vue"
        ),
    }, {
        path: "/ControlManagement/PersonnelViolationAlarm", name: "人员报警记录", component: () => import(
            "../views/ControlManagement/PersonnelViolationAlarm/physicalExaminationStatistics.vue"
        ),
    }, {
        path: "/ControlManagement/MonitoringArea",
        name: "监控区域配置",
        component: () => import("../views/ControlManagement/MonitoringArea/table"),
    }, {
        path: "/ControlManagement/LocationCardManagement", name: "定位卡管理", component: () => import(
            "../views/ControlManagement/LocationCardManagement/physicalExaminationStatistics.vue"
        ),
    },],
}, // 安全检查管理   对应目录---> safetyManagement
{
    path: "/index", name: "安全检查管理", component: () => import("../views/index/index.vue"), children: [{
        path: "safetyManagement/overview",
        name: "安全检查总览",
        component: () => import("@/views/safetyManagement/overview/index.vue"),
    }, {
        path: "safetyManagement/craneHandoverTask",
        name: "天车交接班任务",
        component: () => import("@/views/safetyManagement/craneHandoverTask"),
    }, {
        path: "safetyManagement/craneHandoverRecord",
        name: "天车交接班记录",
        component: () => import("@/views/safetyManagement/craneHandoverRecord"),
    }, {
        path: "safetyManagement/vehicleHandoverTask",
        name: "叉车、装机交接班任务",
        component: () => import("@/views/safetyManagement/vehicleHandoverTask"),
    }, {
        path: "safetyManagement/vehicleHandoverRecord",
        name: "叉车、装机交接班记录",
        component: () => import("@/views/safetyManagement/vehicleHandoverRecord"),
    }, {
        path: "safetyManagement/handoverRecord",
        name: "交接班记录",
        component: () => import("@/views/safetyManagement/handoverRecord"),
    }, {
        path: "safetyManagement/examType",
        name: "检查类型",
        component: () => import("@/views/safetyManagement/examType/examType.vue"),
    }, {
        path: "safetyManagement/safeInspectionItems", name: "检查项目", component: () => import(
            "@/views/safetyManagement/safeInspectionItems/safeInspectionItem.vue"
        ),
    }, {
        path: "safetyManagement/inspectionStandards", name: "检查标准", component: () => import(
            "@/views/safetyManagement/inspectionStandards/inspectionStandards.vue"
        ),
    }, {
        path: "safetyManagement/inspectRecords",
        name: "检查记录",
        component: () => import("@/views/safetyManagement/inspectRecords/inspectRecords.vue"),
    }, {
        path: "safetyManagement/safetyInspectionTask",
        name: "安全检查任务",
        component: () => import("@/views/safetyManagement/safetyInspectionTask"),
    },],
}, // 员工管理       对应目录---> staffManage
{
    path: "/index", name: "员工管理", component: () => import("../views/index/index.vue"),
    children: [{
        path: "staffManage/staffEmployee",
        name: "员工档案",
        component: () => import("../views/staffManage/staffEmployee.vue"),
    }, {
        path: "staffManage/teamSetting",
        name: "班组设置",
        component: () => import("../views/staffManage/teamSetting.vue"),
    }, {
        path: "staffManage/department",
        name: "部门管理",
        component: () => import("../views/staffManage/department.vue"),
    }, {
        path: "staffManage/physicalExaminationStatistics/examinationStatistics",
        name: "考勤统计",
        component: () => import(
            "../views/staffManage/examinationStatistics/physicalExaminationStatistics.vue"
        ),
    },
    {
        path: "staffManage/physicalExaminationStatistics/informationOfEmployees",
        name: "人员档案",
        component: () => import(
            "../views/staffManage/informationOfEmployees/physicalExaminationStatistics.vue"
        ),

    },
    {
        path: "examine/institution",
        name: "制度管理",
        component: () => import(
            "../views/staffManage/examine/employee/table.vue"
        ),
    },
    {
        path: "examine/rewardPunishment",
        name: "奖惩制度",
        component: () => import(
            "../views/staffManage/examine/empRewardsPunishSys/table.vue"
        ),
    },
    {
        path: "examine/manage",
        name: "奖惩管理",
        component: () => import(
            "../views/staffManage/examine/manage/table.vue"
        ),
    },
    {
        path: "examine/AssessmentScore",
        name: "考核评分",
        component: () => import(
            "../views/staffManage/examine/score/table.vue"
        ),
    },
    {
        path: "QuaCerManage",
        name: "资质证书管理",
        component: () => import(
            "../views/staffManage/examine/qualification/table.vue"
        ),
    },


    ],
}, // 作业票管理     对应目录---> jobTicket
{
    path: "/index",
    name: "作业票管理",
    component: () => import("../views/index/index.vue"), children: [{
        path: "/jobTicketAssociated/jobTicketAssociated",
        name: "作业票关联配置",
        component: () => import("@/views/jobTicket/jobSlip/jobSlipCorrelation.vue"),
    },
    {
        path: "/jobUtils/jobTicketPlace",
        name: "作业地点配置",
        component: () => import("@/views/jobTicket/jobPlace/jobPlaceConfiguration.vue"),
    },
    {
        path: "/jobUtils/jobTicketSafetyMeasures", name: "安全措施", component: () => import(
            "@/views/jobTicket/safetyPrecautions/safetyPrecautionsConfiguration.vue"
        ),
    }, {
        path: "/jobUtils/gasAnalysisConfiguration",
        name: "气体分析",
        component: () => import("@/views/jobTicket/gasAnalysis/gasAnalysisConfiguration.vue"),
    }, {
        path: "/jobUtils/safetyDisclosureConfiguration", name: "安全交底", component: () => import(
            "@/views/jobTicket/safetyDisclosure/safetyDisclosureConfiguration.vue"
        ),
    }, {
        path: "/jobUtils/jobClassConfiguration",
        name: "作业类别配置",
        component: () => import("@/views/jobTicket/jobClass/jobClassConfiguration.vue"),
    },
    {
        path: "/jobUtils/JobTicketRecordConfiguration", name: "作业票记录", component: () => import(
            "@/views/jobTicket/JobTicketRecord/JobTicketRecordConfiguration.vue"
        ),
    },

    {
        path: "/jobUtils/jobTicketOverviewConfiguration", name: "作业票总览", component: () => import(
            "@/views/jobTicket/jobTicketOverview/jobTicketOverviewConfiguration.vue"
        ),
    },

    {
        path: "/jobUtils/interested", name: "相关方管理", component: () => import(
            "@/views/jobTicket/interested/table.vue"
        ),
    }
    ],
}, // 双重预防       对应目录---> doublePrevention
{
    path: "/index", name: "双重预防", component: () => import("../views/index/index.vue"), children: [{
        path: "/mechanismOverview",
        name: "双重预防机制概览",
        component: () => import("../views/doublePrevention/mechanismOverview/index.vue"),
    }, {
        path: "/riskHierarchicalControl",
        name: "风险分级管控",
        component: () => import("../views/doublePrevention/riskHierarchicalControl/table.vue"),
    }, {
        path: "/riskHierarchicalControl1", name: "详情", component: () => import(
            "../views/doublePrevention/riskHierarchicalControl/components/riskHierarchicalControl1.vue"
        ),
    }, {
        path: "/hazardDetectionTask",
        name: "隐患排查任务配置",
        component: () => import("../views/doublePrevention/hazardDetectionTask/table.vue"),
    }, {
        path: "patrolManagement/detectionRecord", name: "隐患排查记录", component: () => import(
            "../views/patrolManagement/detectionRecord/detectionRecord.vue"
        ),
    },

    {
        path: "/checkTaskRecord",
        name: "隐患排查任务记录",
        component: () => import("../views/doublePrevention/checkTaskRecord/table.vue"),
    }, {
        path: "/personnelTaskStatus",
        name: "人员任务情况",
        component: () => import("../views/doublePrevention/personnelTaskStatus/table.vue"),
    }, {
        path: "/guaranteeLiability",
        name: "包保责任信息",
        component: () => import("../views/doublePrevention/guaranteeLiability/table.vue"),
    }, {
        path: "/troubleshootingTask",
        name: "排查任务统计",
        component: () => import("../views/doublePrevention/troubleshootingTask/table.vue"),
    }, {
        path: "/mechanismOperation",
        name: "机制运行情况",
        component: () => import("../views/doublePrevention/mechanismOperation/table.vue"),
    }, {
        path: "/automatedMonitoring",
        name: "自动化监控数据",
        component: () => import("../views/doublePrevention/automatedMonitoring/table.vue"),
    }, {
        path: "/automatedMonitoring1", name: "历史预警", component: () => import(
            "../views/doublePrevention/automatedMonitoring/components/automatedMonitoring1.vue"
        ),
    }, {
        path: "/automatedMonitoring2", name: "历史监测数据", component: () => import(
            "../views/doublePrevention/automatedMonitoring/components/automatedMonitoring2.vue"
        ),
    }, {
        path: "/forewarning",
        name: "预警信息",
        component: () => import("../views/doublePrevention/forewarning/table.vue"),
    }, {
        path: "/securityRiskAnalysis",
        name: "安全风险分析对象",
        component: () => import("@/views/doublePrevention/securityRiskAnalysis/index.vue"),
    }, {
        path: "/ProcessType",
        name: "工艺类型",
        component: () => import("@/views/doublePrevention/ProcessType/index.vue"),
    }, {
        path: "/riskAnalysisUnit",
        name: "风险分析单元配置",
        component: () => import("@/views/doublePrevention/riskAnalysisUnit/index.vue"),
    }, {
        path: "/riskEventAllocation",
        name: "风险事件配置",
        component: () => import("@/views/doublePrevention/riskEventAllocation/index.vue"),
    }, {
        path: "/safetySignMaterialLibrary",
        name: "安全标志素材库",
        component: () => import("@/views/doublePrevention/safetySignMaterialLibrary/index.vue"),
    },{
        path: "/riskFourColorChart",
        name: "风险四色图",
        component: () => import("@/views/doublePrevention/riskFourColorChart/index.vue"),
    }, {
        path: "/allocationOfControlMeasures", name: "管控措施配置", component: () => import(
            "@/views/doublePrevention/allocationOfControlMeasures/index.vue"
        ),
    }, {
        path: "/securityRiskAnalysisConfiguration",
        name: "安全风险分析对象停工/检维修配置",
        component: () => import(
            "@/views/doublePrevention/securityRiskAnalysisConfiguration/index.vue"
        ),
    },],
}, // 培训管理       对应目录---> trainingManagement
{
    path: "/index", name: "培训管理", component: () => import("../views/index/index.vue"), children: [{
        path: "/trainingPlan",
        name: "培训计划",
        component: () => import("../views/trainingManagement/trainingPlan/trainingPlan.vue"),
    }, {
        path: "/trainingCourse", name: "培训课程", component: () => import(
            "../views/trainingManagement/trainingCourse/trainingCourse.vue"
        ),
    }, {
        path: "/trainingManagement",
        name: "培训总览",
        component: () => import("@/views/trainingManagement/overview"),
    }, {
        path: "/knowledgeBaseList",
        name: "知识库列表",
        component: () => import("@/views/trainingManagement/knowledgeBaseList/index.vue"),
    }, {
        path: "/knowledgeBaseType",
        name: "知识库类型",
        component: () => import("@/views/trainingManagement/knowledgeBaseType"),
    }, {
        path: "/examPlan",
        name: "考试计划",
        component: () => import("../views/trainingManagement/examPlan/examPlan.vue"),
    }, {
        path: "/ExaminationTypePage",
        name: "考试类型",
        component: () => import("../views/trainingManagement/examination/TypePage.vue"),
    }, {
        path: "/TrainingPlanType",
        name: "培训类型",
        component: () => import("@/views/trainingManagement/trainingPlan/TypePage.vue"),
    }, {
        path: "/TrainingPlanRecords",
        name: "培训记录",
        component: () => import("@/views/trainingManagement/trainingPlan/RecordsPage.vue"),
    }, {
        path: "/TestQuestionsQuestionBank", name: "题库管理", component: () => import(
            "../views/trainingManagement/TestQuestionsPaper/QuestionBank.vue"
        ),
    }, {
        path: "/TestQuestionsType",
        name: "试题类型",
        component: () => import("../views/trainingManagement/TestQuestionsPaper/TypePage"),
    }, {
        path: "/ExaminationRecords",
        name: "考试记录",
        component: () => import("../views/trainingManagement/examination/RecordsPage.vue"),
    }, {
        path: "/SurveyAllocation", name: "培训需求调研配置", component: () => import(
            "../views/trainingManagement/DemandResearch/SurveyAllocation.vue"
        ),
    }, {
        path: "/InvestigationRecord", name: "培训需求调查记录", component: () => import(
            "../views/trainingManagement/DemandResearch/InvestigationRecord.vue"
        ),
    }, {
        path: "/TestPaper", name: "试卷管理", component: () => import(
            "../views/trainingManagement/TestQuestionsPaper/TestPaper.vue"
        ),
    },],
}, // 巡检管理
{
    path: "/index", name: "巡检管理", component: () => import("../views/index/index.vue"), children: [{
        path: "/overviewOfInspection",
        name: "巡检总览",
        component: () => import("../views/inspectionManagement/overviewOfInspection.vue"),
    }, {
        path: "/inspectionTasks",
        name: "巡检任务",
        component: () => import("../views/inspectionManagement/inspectionTasks.vue"),
    }, {
        path: "/inspectionItems",
        name: "巡检项目",
        component: () => import("../views/inspectionManagement/inspectionItems.vue"),
    }, {
        path: "/inspectionStandards",
        name: "巡检标准",
        component: () => import("../views/inspectionManagement/inspectionStandards.vue"),
    }, {
        path: "/inspectionRecords",
        name: "巡检记录",
        component: () => import("../views/inspectionManagement/inspectionRecords.vue"),
    }, {
        path: "/inspectionWarning",
        name: "巡检预警",
        component: () => import("../views/inspectionManagement/inspectionWarning.vue"),
    },],
}, // 其他
{
    path: "/index", name: "其他", component: () => import("../views/index/index.vue"), children: [{
        path: "financeTable/proTable",
        name: "生产成本日报表",
        component: () => import("../views/financeTable/proTable.vue"),
    }, {
        path: "patrolManagement/inspectionItems", name: "巡检项目", component: () => import(
            "../views/patrolManagement/inspectionItems/inspectionItems.vue"
        ),
    }, {
        path: "financeTable/surfaceTable",
        name: "表工日报表",
        component: () => import("../views/financeTable/surfaceTable.vue"),
    },],
}, //     资产管理
{
    path: "/index", name: "资产管理", component: () => import("../views/index/index.vue"), children: [{
        path: "/assetType",
        name: "资产类型",
        component: () => import("../views/assetManagement/assetType/index.vue"),
    }, {
        path: "/aListOfAssets",
        name: "资产列表",
        component: () => import("../views/assetManagement/aListOfAssets/index.vue"),
    }, {
        path: "/qrCodeManagement",
        name: "二维码管理",
        component: () => import("../views/assetManagement/qrCodeManagement/index.vue"),
    }, {
        path: "/warehouseManagement",
        name: "仓库管理",
        component: () => import("../views/assetManagement/warehouseManagement/index.vue"),
    }, {
        path: "/inventoryManagement",
        name: "库存管理",
        component: () => import("../views/assetManagement/inventoryManagement/index.vue"),
    }, {
        path: "/inventoryFlows",
        name: "库存流水",
        component: () => import("../views/assetManagement/inventoryFlows/index.vue"),
    }, {
        path: "/warehouseInventory",
        name: "仓库盘点",
        component: () => import("../views/assetManagement/warehouseInventory/index.vue"),
    }, {
        path: "/documentManagement",
        name: "单据管理",
        component: () => import("../views/assetManagement/documentManagement/index.vue"),
    }],
},];

const router = new VueRouter({
    mode: "hash", base: process.env.BASE_URL, routes,
});

/*
  根据url地址以及当前是否登录进入相关页面，防止地址栏输入地址进入页面
*/
router.beforeEach((to, from, next) => {
    next();
});

export default router;
